import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-catalogs-products-card',
  templateUrl: './catalogs-products-card.component.html',
  styleUrls: ['./catalogs-products-card.component.scss']
})
export class CatalogsProductsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enabledCount: any;
  disabledCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('products-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('products-counts-spinner');
      this.showCounter = true;
      this.enabledCount = this.data.availableProducts;
      this.disabledCount = this.data.unavailableProducts;
    } else if ('-' === this.data) {
      this.enabledCount = '-';
      this.disabledCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('products-counts-spinner');
    }
  }

}
